// @core/stores/chat/ChatPresenceStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { chatApi } from '@core/api';
import type {
  GetPresenceRequest,
  GetPresenceResponse,
  Presence,
  UpdatePresenceRequest,
} from '@core/types/chat';
import type { PageInfo } from '@core/types/pagination';

class ChatPresenceStore {
  // List state
  items: Presence[] = [];
  pageInfo: PageInfo | null = null;

  // Single item state
  currentItem: Presence | null = null;

  // Loading states
  isLoading = false;
  isLoadingItem = false;
  isSaving = false;
  isDeleting = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;
  // Cache by ID
  private cache = new Map<string, Presence>();

  constructor() {
    makeAutoObservable(this);
  }
  // Computed
  get hasMore(): boolean {
    return this.pageInfo?.has_next ?? false;
  }

  get isEmpty(): boolean {
    return this.items.length === 0 && !this.isLoading;
  }

  // Cache helpers
  getById(id: string): Presence | undefined {
    return this.cache.get(id);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }
  clearCurrent(): void {
    this.currentItem = null;
  }

  reset(): void {
    this.items = [];
    this.pageInfo = null;
    this.currentItem = null;
    this.error = null;
    this.cache.clear();
  }

  /**
   * Get presence for users
   */
  async GetPresence(data: GetPresenceRequest): Promise<GetPresenceResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await chatApi.GetPresence(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }

  /**
   * Update presence status
   */
  async UpdatePresence(data: UpdatePresenceRequest): Promise<Response> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await chatApi.UpdatePresence(data);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const chatPresenceStore = new ChatPresenceStore();
